<ng-container *ngFor="let section of dynamicSection">
  <ix-fieldset
    *ngIf="section.schema.length"
    [id]="section.name"
    [title]="section.name | translate"
  >
    <mat-divider class="divider" inset></mat-divider>
    <div class="section">
      <div class="fieldset">
        <ng-container *ngFor="let schema of section.schema">
          <ix-dynamic-form-item
            [id]="schema.controlName"
            [dynamicSchema]="schema"
            [dynamicForm]="dynamicForm"
            [isEditMode]="isEditMode"
            (addListItem)="addControlNext($event)"
            (deleteListItem)="removeControlNext($event)"
          ></ix-dynamic-form-item>
        </ng-container>
      </div>
      <div class="help" [hidden]="!section.help">
        <div class="title">{{ 'Section Help' | translate }}</div>
        <div class="value"> {{ section.help }}</div>
      </div>
    </div>
  </ix-fieldset>
</ng-container>
